<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                {{ 'Equipment' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Location' | translate"
                            v-model="location"
                            name="location"
                            autocomplete="off"
                            :rules="locationRules"
                            required
                          >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                            
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Class' | translate"
                            v-model="equipmentclass"
                            name="equipmentclass"
                            autocomplete="off"
                            :rules="equipmentclassRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Maker' | translate"
                            v-model="maker"
                            name="maker"
                            autocomplete="off"
                            :rules="makerRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Status' | translate"
                            v-model="status"
                            name="status"
                            autocomplete="off"
                            :rules="statusRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            type="number"
                            :label="'Number in stock' | translate"
                            v-model="num_in_stock"
                            name="num_in_stock"
                            autocomplete="off"
                            :rules="numberstockRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">

                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="true"
                            
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                :label="'Good until date' | translate"
                                v-model="good_until"
                                prepend-icon="mdi-calendar"
                                name="good_until"
                                autocomplete="off"
                                v-bind="attrs"
                                v-on="on"
                                :rules="gooduntilldateRules"
                                required
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>                                
                              </v-text-field>


                            </template>
                            <v-date-picker
                              v-model="good_until"
                              no-title
                              scrollable
                              :locale="curLanguage.lang_code"
                              @input="menu=false"
                            >
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Serial number' | translate"
                            v-model="serial_number"
                            name="serial_number"
                            autocomplete="off"
                            :rules="serialnumberRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="procedure"
                            v-model="procedure"
                            :rules="procedureRules"
                            autocomplete="off"
                            :label="'Procedure' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="description"
                            v-model="description"
                            :rules="descriptionRules"
                            autocomplete="off"
                            :label="'Description' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-textarea>
                        </v-col>
                      </v-row>




                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="equipment_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="equipment_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  ADD_EQUIPMENT,
  RESET_STATE,
  FETCH_INDIVIDUAL_EQUIPMENT,
  UPDATE_EQUIPMENT
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addeditEquipment",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_EQUIPMENT, to.params.id).then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualequipment", 'currentUser','curLanguage']),
    ...mapState({
      errors: state => state.equipment.equipmenterrors,
    ...mapState({
      curLanguage: state => state.translations.curLanguage
    }), 
    locationRules(){
      return [v => !!v || "Location is required"]
    },
    equipmentclassRules(){ return [v => !!v || "Class is required"]},   
    makerRules(){ return [v => !!v || "Maker is required"]},
    statusRules(){ return [v => !!v || "Status is required"]},
    numberstockRules(){ return [v => !!v || "Number in stock is required"]},
    gooduntilldateRules(){ return [v => !!v || "Goods until date is required"]},
    serialnumberRules() {return [v => !!v || "Serial number is required"]},
    procedureRules(){ return [v => !!v || "Procedure is required"]},
    descriptionRules(){ return [v => !!v || "Description is required"]}, 
    

    })
  },
  created(){
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false && JSON.parse(this.currentUser.company.company_meta).has_equip_db == "false"){
      this.$router.push('/learningcenter');
    }
  },
  mounted () {
    if(this.individualequipment.length > 0){
      this.equipment_id = this.individualequipment.equipment_id
      this.location = this.individualequipment.location
      this.equipmentclass = this.individualequipment.class
      this.serial_number  = this.individualequipment.serial_number
      this.maker  = this.individualequipment.maker
      this.status = this.individualequipment.status
      this.num_in_stock = this.individualequipment.num_in_stock
      this.good_until = this.individualequipment.good_until
      this.procedure  = this.individualequipment.procedure
      this.description  = this.individualequipment.description
    }
  },
  data: function() {
    return {
      equipment_id: null,
      location: null,
      equipmentclass: null,
      menu: false,
      maker: null,
      status: null,
      num_in_stock: null,
      serial_number: null,
      good_until: null,
      procedure: null,
      description: null,
    }
  },
  methods : {
    submit: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(ADD_EQUIPMENT, {
            location: this.location,
            class: this.equipmentclass,
            maker: this.maker,
            status: this.status,
            serial_number: this.serial_number,
            num_in_stock: this.num_in_stock,
            good_until: this.good_until,
            procedure: this.procedure,
            description: this.description,
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Equipment created successfully'})
              this.$router.push({ name: "equipment" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_EQUIPMENT, {
            location: this.location,
            class: this.equipmentclass,
            maker: this.maker,
            status: this.status,
            num_in_stock: this.num_in_stock,
            serial_number: this.serial_number,
            good_until: this.good_until,
            procedure: this.procedure,
            description: this.description,
            equipment_id: this.equipment_id,
            _method: "put"
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Equipment updated successfully'})
              this.$router.push({ name: "equipment" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>